const baseUrl = process.env.REACT_APP_APIEND;

export const fetchSinToken = async (endpoint, data, method) => {
    const url = `${baseUrl}/${endpoint}`;

    if (method === 'GET') {
        const resp = await fetch(url);
        return await resp.json();
    } else {
        const resp = await fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        return await resp.json();
    }
};

export const fetchConToken = async (endpoint, data, method = 'GET', maxAttempts = 3) => {
    let attempt = 0;

    while (attempt < maxAttempts) {
        try {
            const url = `${baseUrl}/${endpoint}`;
            const token = localStorage.getItem('token') || '';

            let requestOptions = {
                headers: {
                    'x-token': token,
                },
            };

            if (method !== 'GET') {
                requestOptions = {
                    method,
                    headers: {
                        'Content-type': 'application/json',
                        'x-token': token,
                    },
                    body: JSON.stringify(data),
                };
            }

            const resp = await fetch(url, requestOptions);

            return await resp.json();
        } catch (error) {
            if (error.response && error.response.status) {
                console.log('ERROR ', error);
                // Manejar errores específicos si es necesario
                return { ok: false, error };
            } else {
                // Si es un error de conexión, esperar un tiempo antes de intentar nuevamente
                await new Promise((resolve) => setTimeout(resolve, 3000)); // Esperar 1 segundo (ajusta el valor según sea necesario)
                attempt++;
            }
        }
    }

    // Si llegamos a este punto, significa que se han agotado los intentos
    return { ok: false, error: 'Se agotaron los intentos de solicitud' };
};

export const uploadFile = async (bodyContent, endpoint, method = 'PUT') => {
    //
    const token = localStorage.getItem('token') || '';

    const url = `${baseUrl}/${endpoint}`;
    try {
        let headersList = {
            Accept: '*/*',
            'x-token': token,
        };
        let response = await fetch(`${url}`, {
            method,
            body: bodyContent,
            headers: headersList,
        });
        return await response.json();
    } catch (error) {
        return { ok: false, error };
    }
};
